import React, { useEffect, useState, useRef, createContext, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { TutorialVideoSection } from './components/TutorialVideoSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { FoundersNoteSection } from './components/FoundersNoteSection';
import { FAQSection } from './components/FAQSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MoreThanLessonsSection } from './components/MoreThanLessonsSection';
import { VisionSection } from './components/VisionSection';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { TeacherSignUp } from './components/pages/TeacherSignUp';
import { StudentSignUp } from './components/pages/StudentSignUp';
import { StudentLogin } from './components/pages/StudentLogin';
import { TeacherLogin } from './components/pages/TeacherLogin';
import { StudentDashboard } from './components/pages/StudentDashboard';
import { StudentMessages } from './components/pages/StudentMessages';
import { TeacherMessages } from './components/pages/TeacherMessages';
import { FindTeachers } from './components/pages/FindTeachers';
import { CompleteTeacherProfile } from './components/pages/CompleteTeacherProfile';
import { TeacherPublicProfile } from './components/pages/TeacherPublicProfile';
import { TeacherDashboard } from './components/pages/TeacherDashboard';
import { TeacherProfile } from './components/pages/TeacherProfile';
import { ReportsDashboard } from './components/pages/ReportsDashboard';
import { OnlineCourses } from './components/pages/OnlineCourses';
import { PublicCoursesPage } from './components/pages/PublicCoursesPage';
import { MyStudents } from './components/pages/MyStudents';
import { StudentSettings } from './components/pages/StudentSettings';
import { StudentSchedule } from './components/pages/StudentSchedule';
import { StudentProfilePage } from './components/pages/StudentProfilePage';
import { StudentGradesOverview } from './components/pages/StudentGradesOverview';
import { GradesManagementPage } from './components/pages/GradesManagementPage';
import { StudentDataCheck } from './components/pages/StudentDataCheck';
import { AuthProvider } from './contexts/AuthContext';
import { AuthGuard } from './components/AuthGuard';
import { ScrollToTop } from './components/ScrollToTop';
import { SignInModal } from './components/SignInModal';
import { TeacherLoginModal } from './components/TeacherLoginModal';
import { initEmailService } from './services/emailService';
import { EmailVerificationPage } from './components/pages/EmailVerificationPage';
import { InstrumentSelectionPage } from './components/pages/InstrumentSelectionPage';
import { TeacherMatchingPage } from './components/pages/TeacherMatchingPage';
import { SheetMusicPage } from './components/pages/SheetMusicPage';
import { MoonlightSonataViewer } from './components/pages/MoonlightSonataViewer';
import { PreludeInCMajorViewer } from './components/pages/PreludeInCMajorViewer';
import { ToccatinaViewer } from './components/pages/ToccatinaViewer';
import { RondoInEFlatViewer } from './components/pages/RondoInEFlatViewer';
import { PolonaiseInFViewer } from './components/pages/PolonaiseInFViewer';
import { EnglishSuite1Bourree1Viewer } from './components/pages/EnglishSuite1Bourree1Viewer';
import { EnglishSuite1Bourree2Viewer } from './components/pages/EnglishSuite1Bourree2Viewer';
import { EnglishSuite2Bourree1Viewer } from './components/pages/EnglishSuite2Bourree1Viewer';
import { EnglishSuite2Bourree2Viewer } from './components/pages/EnglishSuite2Bourree2Viewer';
import { WTK1Prelude1Viewer } from './components/pages/WTK1Prelude1Viewer';
import { WTK1Fugue1Viewer } from './components/pages/WTK1Fugue1Viewer';
import { WTK1Prelude2Viewer } from './components/pages/WTK1Prelude2Viewer';
import { AusMeinesHerzensGrundeViewer } from './components/pages/AusMeinesHerzensGrundeViewer';
import { IchDankDirLieberHerreViewer } from './components/pages/IchDankDirLieberHerreViewer';
import { ErmuntereDichMeinSchwacherGeistViewer } from './components/pages/ErmuntereDichMeinSchwacherGeistViewer';
import { GottWieGrossIstDeineGuteViewer } from './components/pages/GottWieGrossIstDeineGuteViewer';
import { GibDichZufriedenUndSeiStilleViewer } from './components/pages/GibDichZufriedenUndSeiStilleViewer';
import { GibDichZufriedenUndSeiStilleDMinorViewer } from './components/pages/GibDichZufriedenUndSeiStilleDMinorViewer';
import { AriaBWV515Viewer } from './components/pages/AriaBWV515Viewer';
import { WarumBetrubstDuDichViewer } from './components/pages/WarumBetrubstDuDichViewer';
import { InventionNo2Viewer } from './components/pages/InventionNo2Viewer';
import { InventionNo3Viewer } from './components/pages/InventionNo3Viewer';
import { InventionNo4Viewer } from './components/pages/InventionNo4Viewer';
import { InventionNo5Viewer } from './components/pages/InventionNo5Viewer';
import { InventionNo7Viewer } from './components/pages/InventionNo7Viewer';
import { InventionNo8Viewer } from './components/pages/InventionNo8Viewer';
import { InventionNo10Viewer } from './components/pages/InventionNo10Viewer';
import { InventionNo11Viewer } from './components/pages/InventionNo11Viewer';
import { InventionNo13Viewer } from './components/pages/InventionNo13Viewer';
import { InventionNo14Viewer } from './components/pages/InventionNo14Viewer';
import { InventionNo15Viewer } from './components/pages/InventionNo15Viewer';
import { GenericSheetMusicViewer } from './components/pages/GenericSheetMusicViewer';
import { TeacherTasks } from './components/pages/TeacherTasks';
import { StudentLayout } from './components/layouts/StudentLayout';
import { TeacherLayout } from './components/layouts/TeacherLayout';
import { RoleAwareLayout } from './components/layouts/RoleAwareLayout';
import { VirtualClassroom } from './components/pages/VirtualClassroom';
import { ToastContainer } from './components/ToastContainer';
import { PaymentMethodsPage } from './components/pages/PaymentMethodsPage';
import { TransactionHistoryPage } from './components/pages/TransactionHistoryPage';
import { SubscriptionManagementPage } from './components/pages/SubscriptionManagementPage';
import { Calendar2 } from './components/pages/Calendar2';
import { MyInfoPage } from './components/pages/MyInfoPage';
import { SettingsPage } from './components/pages/SettingsPage';
import { AccountSecurityPage } from './components/pages/AccountSecurityPage';
import { BillingPayoutsPage } from './components/pages/BillingPayoutsPage';
import { HelpSupportPage } from './components/pages/HelpSupportPage';
import { PayoutsInvoicesPage } from './components/pages/PayoutsInvoicesPage';
import { ThemeProvider, useTheme } from './components/providers/ThemeProvider';
import { ForgotPassword } from './components/pages/ForgotPassword';
import { ResetPasswordPage } from './components/pages/ResetPasswordPage';
import { TeacherEmailVerificationPage } from './components/pages/TeacherEmailVerificationPage';
import { VerifyEmailPage } from './components/pages/VerifyEmailPage';
import { EmailVerifiedPage } from './components/pages/EmailVerifiedPage';
import { Toaster } from 'react-hot-toast';
import { RevenuePage } from './components/pages/RevenuePage';
import { TeacherPublicProfilePage } from './components/pages/TeacherPublicProfilePage';
import { AboutUsPage } from './components/pages/AboutUsPage';
import { CareersPage } from './components/pages/CareersPage';
import { KnowledgeBaseGettingStarted } from './components/pages/KnowledgeBaseGettingStarted';
import { KnowledgeBaseSchedulingLessons } from './components/pages/KnowledgeBaseSchedulingLessons';
import { KnowledgeBaseVirtualClassroom } from './components/pages/KnowledgeBaseVirtualClassroom';
import { PrivacyPolicyPage } from './components/pages/PrivacyPolicyPage';
import { CookiePolicyPage } from './components/pages/CookiePolicyPage';
import { TermsOfServicePage } from './components/pages/TermsOfServicePage';
// Note: SignInModalContext and TeacherLoginModalContext are defined locally below via createContext.
// Do NOT re-import them from SignInModal or TeacherLoginModal (circular dependency breaks Safari).
// Create a context for the sign in modal
export const SignInModalContext = createContext({
  isSignInModalOpen: false,
  openSignInModal: () => {},
  closeSignInModal: () => {},
  isTeacherLoginModalOpen: false,
  openTeacherLoginModal: () => {},
  closeTeacherLoginModal: () => {}
});
// Create a wrapper component that uses the theme
function AppContent() {
  const {
    theme
  } = useTheme();
  // Initialize EmailJS when the app loads
  useEffect(() => {
    initEmailService();
  }, []);
  // Set the correct page title (overrides any template/sandbox title)
  useEffect(() => {
    document.title = 'Maestro Connect | Professional Tools for Music Teachers';
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Manage lessons, students, scheduling, and growth — all in one place. Built specifically for private music educators.';
    // Set Open Graph tags
    const ogTags: Record<string, string> = {
      'og:title': 'Maestro Connect | Professional Tools for Music Teachers',
      'og:description': 'Manage lessons, students, scheduling, and growth — all in one place. Built specifically for private music educators.',
      'og:type': 'website',
      'og:url': 'https://maestroconnect.io/',
      'og:image': 'https://uploadthingy.s3.us-west-1.amazonaws.com/1YYDABxxgC3iLBdkcPAnB8/Pianist.jpg',
      'og:image:width': '1200',
      'og:image:height': '630'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  // Global state for sign in modal
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [isTeacherLoginModalOpen, setIsTeacherLoginModalOpen] = useState(false);
  // EMAIL VERIFICATION FIX: Track if modal was opened via verification redirect
  // This ref prevents auth state transitions from closing the modal
  const modalOpenedByVerification = useRef(false);
  const openSignInModal = () => {
    setIsSignInModalOpen(true);
  };
  const closeSignInModal = () => {
    setIsSignInModalOpen(false);
  };
  const openTeacherLoginModal = () => {
    setIsTeacherLoginModalOpen(true);
  };
  const closeTeacherLoginModal = () => {
    modalOpenedByVerification.current = false;
    setIsTeacherLoginModalOpen(false);
  };
  // EMAIL VERIFICATION FIX: Auto-open TeacherLoginModal when redirected from email verification
  // When EmailVerifiedPage redirects unauthenticated users to /?openLogin=true&verified=true,
  // this effect detects the param and opens the login modal automatically.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('openLogin') === 'true') {
      console.log('[App] Detected openLogin param — auto-opening Teacher Login modal');
      modalOpenedByVerification.current = true;
      // Small delay to ensure the app is fully mounted before opening modal
      const timer = setTimeout(() => {
        setIsTeacherLoginModalOpen(true);
        // Clean up URL params without triggering navigation
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, []);
  return <AuthProvider data-id="element-0">
      <SignInModalContext.Provider value={{
      isSignInModalOpen,
      openSignInModal,
      closeSignInModal,
      isTeacherLoginModalOpen,
      openTeacherLoginModal,
      closeTeacherLoginModal
    }} data-id="element-1">
        <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-2">
          <BrowserRouter data-id="element-3">
            <ScrollToTop data-id="element-4" />
            <Routes data-id="element-5">
              <Route path="/" element={<>
                    <Navbar data-id="element-7" />
                    <main data-id="element-8">
                      <HeroSection data-id="element-9" />
                      <TutorialVideoSection data-id="element-10" />
                      <HowItWorksSection data-id="element-11" />
                      <BenefitsSection data-id="element-12" />
                      <MoreThanLessonsSection data-id="element-13" />
                      <TestimonialsSection data-id="element-14" />
                      <FoundersNoteSection data-id="element-15" />
                      <VisionSection data-id="element-16" />
                      <PricingSection data-id="element-17" />
                      <FAQSection data-id="element-18" />
                    </main>
                    <Footer data-id="element-19" />
                  </>} data-id="element-6" />
              <Route path="/teacher-signup" element={<TeacherSignUp data-id="element-21" />} data-id="element-20" />
              <Route path="/student-signup" element={<StudentSignUp data-id="element-23" />} data-id="element-22" />
              <Route path="/forgot-password" element={<ForgotPassword data-id="element-25" />} data-id="element-24" />
              <Route path="/reset-password" element={<ResetPasswordPage data-id="element-27" />} data-id="element-26" />
              <Route path="/student-login" element={<StudentLogin data-id="element-29" />} data-id="element-28" />
              <Route path="/teacher-login" element={<TeacherLogin data-id="element-31" />} data-id="element-30" />

              {/* Email verification routes - NO AUTH GUARD (must be accessible to unverified users) */}
              <Route path="/email-verification" element={<EmailVerificationPage data-id="element-33" />} data-id="element-32" />
              <Route path="/teacher-email-verification" element={<TeacherEmailVerificationPage data-id="element-35" />} data-id="element-34" />
              {/* New route for email verification success */}
              <Route path="/email-verified" element={<EmailVerifiedPage data-id="element-37" />} data-id="element-36" />
              {/* Legacy route for handling email verification links - kept for backward compatibility */}
              <Route path="/verify-email" element={<VerifyEmailPage data-id="element-39" />} data-id="element-38" />

              {/* Student routes with consistent sidebar */}
              <Route path="/student-dashboard" element={<StudentLayout data-id="element-41">
                    <StudentDashboard data-id="element-42" />
                  </StudentLayout>} data-id="element-40" />
              <Route path="/messages" element={<StudentLayout data-id="element-44">
                    <StudentMessages data-id="element-45" />
                  </StudentLayout>} data-id="element-43" />
              <Route path="/find-teachers" element={<StudentLayout data-id="element-47">
                    <FindTeachers data-id="element-48" />
                  </StudentLayout>} data-id="element-46" />
              <Route path="/online-courses" element={<StudentLayout data-id="element-50">
                    <OnlineCourses data-id="element-51" />
                  </StudentLayout>} data-id="element-49" />
              <Route path="/sheet-music" element={<StudentLayout data-id="element-53">
                    <SheetMusicPage data-id="element-54" />
                  </StudentLayout>} data-id="element-52" />
              <Route path="/student-settings" element={<StudentLayout data-id="element-56">
                    <StudentSettings data-id="element-57" />
                  </StudentLayout>} data-id="element-55" />
              {/* PHASE 2: Student self-profile route */}
              <Route path="/student/profile" element={<StudentLayout data-id="element-59">
                    <div className="min-h-screen flex items-center justify-center" data-id="element-60">
                      <p className="text-gray-500" data-id="element-61">Profile page coming soon</p>
                    </div>
                  </StudentLayout>} data-id="element-58" />
              <Route path="/my-profile" element={<StudentLayout data-id="element-63">
                    <div className="min-h-screen flex items-center justify-center" data-id="element-64">
                      <p className="text-gray-500" data-id="element-65">Profile page coming soon</p>
                    </div>
                  </StudentLayout>} data-id="element-62" />

              {/* Teacher routes - PROTECTED with email verification enforcement */}
              <Route path="/teacher-dashboard" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-67">
                    <TeacherDashboard data-id="element-68" />
                  </AuthGuard>} data-id="element-66" />
              <Route path="/teacher-profile" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-70">
                    <TeacherPublicProfilePage data-id="element-71" />
                  </AuthGuard>} data-id="element-69" />

              {/* Teacher calendar routes - PROTECTED */}
              <Route path="/teacher/calendar" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-73">
                    <TeacherLayout data-id="element-74">
                      <Calendar2 data-id="element-75" />
                    </TeacherLayout>
                  </AuthGuard>} data-id="element-72" />
              <Route path="/teacher/calendar2" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-77">
                    <TeacherLayout data-id="element-78">
                      <Calendar2 data-id="element-79" />
                    </TeacherLayout>
                  </AuthGuard>} data-id="element-76" />

              {/* Public teacher profile routes - NO AUTH GUARD (public pages) */}
              <Route path="/teachers/:teacherId" element={<TeacherPublicProfilePage data-id="element-81" />} data-id="element-80" />

              {/* Teacher-only routes - PROTECTED */}
              <Route path="/revenue" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-83">
                    <RevenuePage data-id="element-84" />
                  </AuthGuard>} data-id="element-82" />
              <Route path="/assigned-tasks" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-86">
                    <TeacherTasks data-id="element-87" />
                  </AuthGuard>} data-id="element-85" />
              <Route path="/reports" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-89">
                    <ReportsDashboard data-id="element-90" />
                  </AuthGuard>} data-id="element-88" />
              <Route path="/payouts" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-92">
                    <PayoutsInvoicesPage data-id="element-93" />
                  </AuthGuard>} data-id="element-91" />
              <Route path="/complete-profile" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-95">
                    <CompleteTeacherProfile data-id="element-96" />
                  </AuthGuard>} data-id="element-94" />
              <Route path="/my-students" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-98">
                    <MyStudents data-id="element-99" />
                  </AuthGuard>} data-id="element-97" />
              <Route path="/student-data-check" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-101">
                    <StudentDataCheck data-id="element-102" />
                  </AuthGuard>} data-id="element-100" />
              <Route path="/teacher-messages" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-104">
                    <TeacherLayout data-id="element-105">
                      <TeacherMessages data-id="element-106" />
                    </TeacherLayout>
                  </AuthGuard>} data-id="element-103" />

              {/* Public routes - NO AUTH GUARD */}
              <Route path="/courses" element={<PublicCoursesPage data-id="element-108" />} data-id="element-107" />
              <Route path="/teacher/:id" element={<TeacherPublicProfilePage data-id="element-110" />} data-id="element-109" />
              <Route path="/public-profile/:teacherId" element={<TeacherPublicProfilePage data-id="element-112" />} data-id="element-111" />

              {/* Virtual classroom and grades - context-dependent protection */}
              <Route path="/student/lesson/:lessonId/join" element={<VirtualClassroom data-id="element-114" />} data-id="element-113" />
              <Route path="/student-grades/:studentId" element={<StudentGradesOverview data-id="element-116" />} data-id="element-115" />
              <Route path="/grades-management" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-118">
                    <GradesManagementPage data-id="element-119" />
                  </AuthGuard>} data-id="element-117" />

              {/* Teacher Sheet Music page - PROTECTED */}
              <Route path="/teacher-sheet-music" element={<AuthGuard requiredUserType="teacher" redirectTo="/teacher-login" data-id="element-121">
                    <SheetMusicPage data-id="element-122" />
                  </AuthGuard>} data-id="element-120" />

              {/* Sheet music viewer pages - NO AUTH GUARD (public access) */}
              <Route path="/sheet-music/moonlight-sonata" element={<MoonlightSonataViewer data-id="element-124" />} data-id="element-123" />
              <Route path="/sheet-music/prelude-in-c-major" element={<PreludeInCMajorViewer data-id="element-126" />} data-id="element-125" />
              <Route path="/sheet-music/toccatina" element={<ToccatinaViewer data-id="element-128" />} data-id="element-127" />
              <Route path="/sheet-music/rondo-in-e-flat" element={<RondoInEFlatViewer data-id="element-130" />} data-id="element-129" />
              <Route path="/sheet-music/polonaise-in-f" element={<PolonaiseInFViewer data-id="element-132" />} data-id="element-131" />
              <Route path="/sheet-music/english-suite-1-bourree-1" element={<EnglishSuite1Bourree1Viewer data-id="element-134" />} data-id="element-133" />
              <Route path="/sheet-music/english-suite-1-bourree-2" element={<EnglishSuite1Bourree2Viewer data-id="element-136" />} data-id="element-135" />
              <Route path="/sheet-music/english-suite-2-bourree-1" element={<EnglishSuite2Bourree1Viewer data-id="element-138" />} data-id="element-137" />
              <Route path="/sheet-music/english-suite-2-bourree-2" element={<EnglishSuite2Bourree2Viewer data-id="element-140" />} data-id="element-139" />
              <Route path="/sheet-music/wtk1-prelude-c-major" element={<WTK1Prelude1Viewer data-id="element-142" />} data-id="element-141" />
              <Route path="/sheet-music/wtk1-fugue-c-major" element={<WTK1Fugue1Viewer data-id="element-144" />} data-id="element-143" />
              <Route path="/sheet-music/wtk1-prelude-c-minor" element={<WTK1Prelude2Viewer data-id="element-146" />} data-id="element-145" />
              <Route path="/sheet-music/aus-meines-herzens-grunde" element={<AusMeinesHerzensGrundeViewer data-id="element-148" />} data-id="element-147" />
              <Route path="/sheet-music/ich-dank-dir-lieber-herre" element={<IchDankDirLieberHerreViewer data-id="element-150" />} data-id="element-149" />
              <Route path="/sheet-music/ermuntere-dich-mein-schwacher-geist" element={<ErmuntereDichMeinSchwacherGeistViewer data-id="element-152" />} data-id="element-151" />
              <Route path="/sheet-music/gott-wie-gross-ist-deine-gute" element={<GottWieGrossIstDeineGuteViewer data-id="element-154" />} data-id="element-153" />
              <Route path="/sheet-music/gib-dich-zufrieden-und-sei-stille" element={<GibDichZufriedenUndSeiStilleViewer data-id="element-156" />} data-id="element-155" />
              <Route path="/sheet-music/gib-dich-zufrieden-und-sei-stille-d-minor" element={<GibDichZufriedenUndSeiStilleDMinorViewer data-id="element-158" />} data-id="element-157" />
              <Route path="/sheet-music/aria-bwv-515" element={<AriaBWV515Viewer data-id="element-160" />} data-id="element-159" />
              <Route path="/sheet-music/warum-betrubst-du-dich" element={<WarumBetrubstDuDichViewer data-id="element-162" />} data-id="element-161" />
              <Route path="/sheet-music/invention-no-2" element={<InventionNo2Viewer data-id="element-164" />} data-id="element-163" />
              <Route path="/sheet-music/invention-no-3" element={<InventionNo3Viewer data-id="element-166" />} data-id="element-165" />
              <Route path="/sheet-music/invention-no-4" element={<InventionNo4Viewer data-id="element-168" />} data-id="element-167" />
              <Route path="/sheet-music/invention-no-5" element={<InventionNo5Viewer data-id="element-170" />} data-id="element-169" />
              <Route path="/sheet-music/invention-no-7" element={<InventionNo7Viewer data-id="element-172" />} data-id="element-171" />
              <Route path="/sheet-music/invention-no-8" element={<InventionNo8Viewer data-id="element-174" />} data-id="element-173" />
              <Route path="/sheet-music/invention-no-10" element={<InventionNo10Viewer data-id="element-176" />} data-id="element-175" />
              <Route path="/sheet-music/invention-no-11" element={<InventionNo11Viewer data-id="element-178" />} data-id="element-177" />
              <Route path="/sheet-music/invention-no-13" element={<InventionNo13Viewer data-id="element-180" />} data-id="element-179" />
              <Route path="/sheet-music/invention-no-14" element={<InventionNo14Viewer data-id="element-182" />} data-id="element-181" />
              <Route path="/sheet-music/invention-no-15" element={<InventionNo15Viewer data-id="element-184" />} data-id="element-183" />
              <Route path="/sheet-music/view/:id" element={<GenericSheetMusicViewer data-id="element-186" />} data-id="element-185" />

              {/* Student registration flow - NO AUTH GUARD */}
              <Route path="/instrument-selection" element={<InstrumentSelectionPage data-id="element-188" />} data-id="element-187" />
              <Route path="/teacher-matching" element={<TeacherMatchingPage data-id="element-190" />} data-id="element-189" />

              {/* Payment related routes */}
              <Route path="/payment-methods" element={<StudentLayout data-id="element-192">
                    <PaymentMethodsPage data-id="element-193" />
                  </StudentLayout>} data-id="element-191" />
              <Route path="/transaction-history" element={<StudentLayout data-id="element-195">
                    <TransactionHistoryPage data-id="element-196" />
                  </StudentLayout>} data-id="element-194" />
              <Route path="/subscription" element={<StudentLayout data-id="element-198">
                    <SubscriptionManagementPage data-id="element-199" />
                  </StudentLayout>} data-id="element-197" />

              {/* Account Management Routes - Role-aware, will apply teacher verification through RoleAwareLayout */}
              <Route path="/my-info" element={<RoleAwareLayout data-id="element-201">
                    <MyInfoPage data-id="element-202" />
                  </RoleAwareLayout>} data-id="element-200" />
              <Route path="/settings" element={<RoleAwareLayout data-id="element-204">
                    <SettingsPage data-id="element-205" />
                  </RoleAwareLayout>} data-id="element-203" />
              <Route path="/account-security" element={<RoleAwareLayout data-id="element-207">
                    <AccountSecurityPage data-id="element-208" />
                  </RoleAwareLayout>} data-id="element-206" />
              <Route path="/billing-payouts" element={<RoleAwareLayout data-id="element-210">
                    <BillingPayoutsPage data-id="element-211" />
                  </RoleAwareLayout>} data-id="element-209" />
              <Route path="/help-support" element={<RoleAwareLayout data-id="element-213">
                    <HelpSupportPage data-id="element-214" />
                  </RoleAwareLayout>} data-id="element-212" />

              {/* Public info pages - NO AUTH GUARD */}
              <Route path="/about" element={<TeacherLayout data-id="element-216">
                    <AboutUsPage data-id="element-217" />
                  </TeacherLayout>} data-id="element-215" />
              <Route path="/knowledge-base/getting-started" element={<TeacherLayout data-id="element-219">
                    <KnowledgeBaseGettingStarted data-id="element-220" />
                  </TeacherLayout>} data-id="element-218" />
              <Route path="/knowledge-base/scheduling-lessons" element={<TeacherLayout data-id="element-222">
                    <KnowledgeBaseSchedulingLessons data-id="element-223" />
                  </TeacherLayout>} data-id="element-221" />
              <Route path="/knowledge-base/virtual-classroom" element={<TeacherLayout data-id="element-225">
                    <KnowledgeBaseVirtualClassroom data-id="element-226" />
                  </TeacherLayout>} data-id="element-224" />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-228" />} data-id="element-227" />
              <Route path="/cookie-policy" element={<CookiePolicyPage data-id="element-230" />} data-id="element-229" />
              <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-232" />} data-id="element-231" />
            </Routes>
            {/* Single instance of SignInModal */}
            <SignInModal isOpen={isSignInModalOpen} onClose={closeSignInModal} data-id="element-233" />
            {/* Single instance of TeacherLoginModal */}
            <TeacherLoginModal isOpen={isTeacherLoginModalOpen} onClose={closeTeacherLoginModal} data-id="element-234" />
            {/* Add ToastContainer */}
            <ToastContainer position="top-right" data-id="element-235" />
            {/* Add Toaster for react-hot-toast */}
            <Toaster position="top-center" toastOptions={{
            duration: 5000,
            style: {
              background: theme === 'dark' ? '#1A2A52' : '#ffffff',
              color: theme === 'dark' ? '#ffffff' : '#1f2937',
              minWidth: '300px',
              padding: '16px',
              fontSize: '14px'
            },
            success: {
              iconTheme: {
                primary: '#4ade80',
                secondary: 'white'
              },
              style: {
                background: theme === 'dark' ? '#1A2A52' : '#ffffff',
                border: theme === 'dark' ? '1px solid rgba(74, 222, 128, 0.3)' : '1px solid rgba(74, 222, 128, 0.2)'
              }
            }
          }} containerStyle={{
            top: 80,
            zIndex: 9999
          }} data-id="element-236" />
          </BrowserRouter>
          <style jsx global data-id="element-237">{`
            html {
              scroll-behavior: smooth;
            }
            /* Global CSS variables for dropdown styling */
            :root {
              --navy-700: #0a1128;
              --navy-800: #1a2a52;
              --navy-900: #0f1626;
              --deep-pink: #e63946;
              --dropdown-shadow:
                0 10px 15px -3px rgba(0, 0, 0, 0.1),
                0 4px 6px -2px rgba(0, 0, 0, 0.05);
            }
            /* Global select dropdown styling - use CSS variables for theming */
            select option {
              background-color: var(--dropdown-bg, #1f2937);
              color: var(--dropdown-text, white);
            }
            select option:checked {
              background-color: var(--dropdown-bg-selected, #394b6c);
              color: var(--dropdown-text-selected, white);
            }
            select option:hover {
              background-color: var(--dropdown-bg-hover, #2e3e5c);
            }
            select {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
              background-position: right 0.5rem center;
              background-repeat: no-repeat;
              background-size: 1.5em 1.5em;
              padding-right: 2.5rem;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              border-radius: 0.5rem;
            }
            select:focus {
              z-index: 10;
            }
            select::-ms-expand {
              display: none;
            }
            select option:checked,
            select option:focus,
            select option:active,
            select option:hover:checked {
              background-color: var(--dropdown-bg-selected, #394b6c) !important;
              color: var(--dropdown-text-selected, white) !important;
              box-shadow: 0 0 10px 100px var(--dropdown-bg-selected, #394b6c)
                inset !important;
              -webkit-text-fill-color: var(
                --dropdown-text-selected,
                white
              ) !important;
            }
            /* Dark mode styles for date and time inputs */
            input[type='date'],
            input[type='time'] {
              color-scheme: auto;
            }
            .bg-navy-900 input[type='date'],
            .bg-navy-900 input[type='time'],
            .bg-navy-800 input[type='date'],
            .bg-navy-800 input[type='time'] {
              color-scheme: dark;
            }
            /* Specific dark mode overrides for navy theme */
            .bg-navy-900 {
              background-color: #0a1128 !important;
            }
            .bg-navy-800 {
              background-color: #1a2a52 !important;
            }
            /* Calendar and time picker dropdown styling */
            .bg-navy-900::-webkit-calendar-picker-indicator,
            .bg-navy-800::-webkit-calendar-picker-indicator {
              filter: invert(1);
              background-color: transparent;
            }
            /* Time dropdown styling for dark mode */
            input[type='time']::-webkit-calendar-picker-indicator {
              background-color: transparent;
            }
            /* Dark mode time dropdown background */
            input[type='time']::-webkit-time-picker,
            input[type='time']::-webkit-datetime-edit,
            input[type='time']::-webkit-inner-spin-button,
            input[type='time']::-webkit-clear-button {
              color: white;
            }
            /* Style the time dropdown background in dark mode */
            .bg-navy-900 input[type='time']::-webkit-list-button,
            .bg-navy-800 input[type='time']::-webkit-list-button,
            .bg-navy-900 input[type='time']::-webkit-time-picker,
            .bg-navy-800 input[type='time']::-webkit-time-picker,
            .bg-navy-900
              input[type='time']::-webkit-datetime-edit-fields-wrapper,
            .bg-navy-800
              input[type='time']::-webkit-datetime-edit-fields-wrapper {
              background-color: rgba(
                26,
                42,
                82,
                0.5
              ); /* #1A2A52 with 50% opacity */
              color: white;
            }
            /* Weekend cells style for time dropdown */
            .bg-navy-900 input[type='time'].weekend::-webkit-time-picker,
            .bg-navy-800 input[type='time'].weekend::-webkit-time-picker {
              background-color: rgba(
                26,
                42,
                82,
                0.3
              ); /* #1A2A52 with 30% opacity */
            }
            /* Override browser default styles for the time dropdown in dark mode */
            @media (prefers-color-scheme: dark) {
              input[type='time']::-webkit-calendar-picker-dropdown {
                background-color: rgba(
                  26,
                  42,
                  82,
                  0.5
                ) !important; /* #1A2A52 with 50% opacity */
              }
            }
            /* Firefox specific styles for dark mode time picker */
            @-moz-document url-prefix() {
              .bg-navy-900 input[type='time'],
              .bg-navy-800 input[type='time'] {
                background-color: rgba(
                  26,
                  42,
                  82,
                  0.5
                ); /* #1A2A52 with 50% opacity */
                color: white;
              }
            }
            /* Light background override */
            .bg-white select option {
              background-color: white;
              color: #1f2937;
            }
            .bg-white select option:checked {
              background-color: #394b6c;
              color: white;
            }
            .bg-white select option:hover {
              background-color: #f3f4f6;
              color: #1f2937;
            }
            .bg-white select option:checked,
            .bg-white select option:focus,
            .bg-white select option:active,
            .bg-white select option:hover:checked {
              background-color: #394b6c !important;
              color: white !important;
              box-shadow: 0 0 10px 100px #394b6c inset !important;
            }
            /* Remove the hardcoded student dropdown styles that were overriding our theme variables */
            /* The styles below will be replaced by the component-level CSS in FindTeachers.tsx */
          `}</style>
        </div>
      </SignInModalContext.Provider>
    </AuthProvider>;
}
export function App() {
  return <ThemeProvider data-id="element-238">
      <AppContent data-id="element-239" />
    </ThemeProvider>;
}